export default "__VITE_ASSET__aLhRUw1C__"